import type { DropDownOption } from '@noths/polaris-client-ribbons-design-system';

import type { RadioButtonData } from 'src/components/molecules/RadioButtonGroup/RadioButtonGroup';
import type { DialingCode } from 'src/types/registration';

export const BUSINESS_REGISTRATION_TYPES: RadioButtonData<string>[] = [
  {
    labelText: 'My business is registered with Companies House',
    value: 'COMPANIES_HOUSE_REGISTERED',
  },
  { labelText: "I'm a sole trader", value: 'SOLE_TRADER' },
  { labelText: 'Other', value: 'OTHER' },
];

export const COUNTRY_CODES: DropDownOption[] = [
  {
    optionLabel: 'Country',
    optionValue: '',
    disabled: true,
  },
  {
    optionLabel: 'United Kingdom',
    optionValue: 'GB',
  },
  {
    optionLabel: 'Republic of Ireland',
    optionValue: 'IE',
  },
];

export const DIALING_CODE: Record<'uk' | 'ireland', DialingCode> = {
  uk: '44',
  ireland: '353',
};

export const DIALING_CODES: DropDownOption[] = [
  {
    optionLabel: 'Country code',
    optionValue: '',
    disabled: true,
  },
  {
    optionLabel: 'United Kingdom [44]',
    optionValue: DIALING_CODE.uk,
  },
  {
    optionLabel: 'Republic of Ireland [353]',
    optionValue: DIALING_CODE.ireland,
  },
];

export const SOURCES: DropDownOption[] = [
  {
    optionLabel: 'Please select',
    optionValue: '',
    disabled: true,
  },
  {
    optionLabel: 'Current seller',
    optionValue: 'CURRENT_SELLER',
  },
  {
    optionLabel: 'Magazine',
    optionValue: 'MAGAZINE',
  },
  {
    optionLabel: 'Newspaper',
    optionValue: 'NEWSPAPER',
  },
  {
    optionLabel: 'Friend',
    optionValue: 'FRIEND',
  },
  {
    optionLabel: 'Google',
    optionValue: 'GOOGLE',
  },
  {
    optionLabel: 'Another website',
    optionValue: 'ANOTHER_WEBSITE',
  },
  {
    optionLabel: 'Customer email',
    optionValue: 'CUSTOMER_EMAIL',
  },
  {
    optionLabel: 'Other',
    optionValue: 'OTHER',
  },
];
